<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>Live Chats
         <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows  + ")": ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec hidden">
        <a href="/pages/knowledge-base/category-chatgroups/question-2">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span> Need help with this section?
        </a>
      </div>
    </div>
    <!-- <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Role</label>
          <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
        </div>
      </div>
    </vx-card>-->



    <div
      class="vx-card p-6 blank-attendee" v-show="chatgroupData.length < 1"
    >
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <img src="../../assets/images/blank-page-images/sponsors.png"/>
          <!--<feather-icon class="" icon="UsersIcon" />-->
        </div>
        <div class="entity-create-desc">
          <h2>Create Chat Group</h2>
          <p>Here you can add chatgroups and group them under categories such as Gold/Silver. They will be displayed as per your preferred order in the Chatgroup screen of the events platform.</p>
          <div class="entity-setup-buttons">
            
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="$router.push('/event/addchatgroup')"
              >CREATE CHAT GROUP</vs-button
            >
            
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card p-6" v-show="chatgroupData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ chatgroupData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : chatgroupData.length }} of {{ chatgroupData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!--ADD -->
        
        <vs-button class="mr-4" type="filled" color="rgb(76, 139, 246)" v-on:click="createNewChatGrp()">Create Chat Group</vs-button>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="OpenSponserExportModal()">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Reports</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown> -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="chatgroupData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import moment from "moment-timezone";
import draggable from "vuedraggable";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

// Store Module
import moduleChatgroupManagement from "@/store/chatgroup-management/moduleChatgroupManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererExport from "./cell-renderer/CellRendererExport.vue";
import ls from "@/common/localStorage";
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
//console.log(db);

export default {
  components: {
    draggable,
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererExport,
  },
  data() {
    return {
      sponserExportList: [],
      gridSelectedRows: 0,
      CategoryColor: "",
      TextBoxShowingId: -1,
      CategoryList: [],
      pageLoaded: false,      
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          //headerName: 'ID',
          //field: 'roomId',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        /*{
          headerName: "Icon",
          field: "iconUrl",
          filter: false,
          width: 100,
          cellRendererFramework: "CellRendererLink",
        },*/
        {
          headerName: "Chat Group",
          field: "roomName",
          filter: true,
          width: 250,
          cellRendererFramework: "CellRendererLink",
          cellRendererParams: (params) => {
            return params;
          },
        },
        {
         headerName: 'Top 5 Participants',
         field: 'topContributors',
         cellRenderer: (data) => {
            if(data.value.length){
              data.value.sort((a, b) => {
                let fa = a.rank;
                let fb = b.rank;
                if (fa < fb) {
                  return -1;
                }
                if (fa > fb) {
                  return 1;
                }
                return 0;
              });
              let names = data.value.map(item=>{ return '<span class="participant-initials">'+item.userName.split(" ").map((n)=>n[0]).join("")+'</span>' })
              return names.join(' ');
            }else{
              return 'NA';
            }
         },
         filter: true,
         width: 250
        },
        {
         headerName: 'Active Users',
         field: 'totActiveUserCount',
         /*cellRenderer: (data) => {
              return data.value ? moment.unix(data.value).format('MMM DD, YYYY HH:mm A') : '';
         },*/
         filter: true,
         width: 150
        },
        {
          headerName: "File Shared",
          field: "totFileShareCount",
          filter: true,
          width: 150,
          /*cellRenderer: (data) => {
              return data.value ? data.value.length : 0;
         },*/
        },
        {
          headerName: "Image Shared",
          field: "totImageShareCount",
          filter: true,
          width: 150          
        },
        {
          headerName: "Message Posted",
          field: "totMessagePostCount",
          filter: true,
          width: 150          
        },
        {
          headerName: "Video Calls",
          field: "totVideoCallCount",
          filter: true,
          width: 150          
        },
        {
          headerName: "Last Activity",
          field: "lastActivityDtmUTC",
          filter: true,
          width: 150,
          cellRenderer: (data) => {
              return data.value ? moment(data.value).tz(Session_Event_TZ).fromNow() : '';
          },      
        },
        {
          headerName: "Export",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererExport",
          cellRendererParams: (params) => {
            return params;
          },
          pinned: "right",
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererExport,
      },
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    chatgroupData() {
      return this.$store.state.chatgroupManagement.chatgroupstat;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    createNewChatGrp(){
        this.$router.push(`/event/chat`).catch(() => {});
    },
    addRecord() {
      this.$router.push(`/event/addchatgroup`).catch(() => {});
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay()
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if (!moduleChatgroupManagement.isRegistered) {
      this.$store.registerModule("chatgroupManagement", moduleChatgroupManagement);
      moduleChatgroupManagement.isRegistered = true;
    }
     this.$vs.loading();
    this.$store.dispatch("chatgroupManagement/fetchChatgroupsStat").then((res) => {
        this.pageLoaded = true;
        this.$vs.loading.close();
      })
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>